import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=264d5341&scoped=true&"
import script from "./videoPlayer.vue?vue&type=script&lang=ts&"
export * from "./videoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=264d5341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d5341",
  null
  
)

export default component.exports